import React from "react";

const TABS = [
  {
    id: "portfolio",
    label: "Portfolio Overview",
  },
  {
    id: "scenario",
    label: "Scenario Analysis",
  },
  {
    id: "coverage",
    label: "Coverage Portfolio",
  },
  {
    id: "decision_analysis",
    label: "Decision Analysis",
  },
];

export default function RiskFinancingTabs({
  activeTab,
  onTabChange,
}) {
  return (
    <div className="flex gap-2 border-b border-slate-200">
      {TABS.map((tab) => {
        const isActive =
          activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() =>
              onTabChange(tab.id)
            }
            className={`px-4 py-2 text-sm font-medium border-b-2 ${
              isActive
                ? "border-slate-900 text-slate-900"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}